import axios from "axios";
const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:4000";
const BASE_URL = `${BACKEND_URL}/api/v1`;

export const getGruposTrabajo = async (token) => {
  const res = await axios.get(`${BASE_URL}/grupos-trabajo`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const createGrupoTrabajo = async (token, data) => {
  const res = await axios.post(`${BASE_URL}/grupos-trabajo`, data, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const updateGrupoTrabajo = async (token, id, data) => {
  const res = await axios.put(`${BASE_URL}/grupos-trabajo/${id}`, data, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};

export const deleteGrupoTrabajo = async (token, id) => {
  const res = await axios.delete(`${BASE_URL}/grupos-trabajo/${id}`, { headers: { Authorization: `Bearer ${token}` } });
  return res.data;
};
